import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface DeleteContractDialogProps {
  contractName: string;
  onConfirm: () => void;
  disabled?: boolean;
  disabledReason?: string;
}

export default function DeleteContractDialog({
  contractName,
  onConfirm,
  disabled = false,
  disabledReason,
}: DeleteContractDialogProps) {
  const description =
    disabled && disabledReason
      ? `${disabledReason} Contrato: "${contractName}".`
      : `Tem certeza que deseja excluir "${contractName}"? Esta ação não pode ser desfeita.`;
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          disabled={disabled}
          className="shrink-0 text-xs font-light uppercase tracking-widest text-red-700 hover:text-red-900 dark:text-red-300 dark:hover:text-red-100"
          onClick={(e) => e.stopPropagation()}
        >
          Excluir
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="rounded-none border-primary-200">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-light tracking-tight text-primary-950 uppercase">
            Excluir Contrato
          </AlertDialogTitle>
          <AlertDialogDescription className="font-light text-primary-600">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-6 border-t border-primary-100 pt-4">
          <AlertDialogCancel
            disabled={disabled}
            className="rounded-none border-primary-200 font-light tracking-widest uppercase text-xs"
          >
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            destructive
            disabled={disabled}
            className="rounded-none tracking-widest uppercase text-xs"
            onClick={onConfirm}
          >
            Excluir
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
